<div class="row">

    <p-toast></p-toast>

    <div style="height: 70px;background: #FDE2C2;text-align: center;margin-left:50px ; 
    color: #2C3F91;font-size: 16px;font-weight: bold;width: 200px!important;">
        <div class='middle-div' style="background: #FDE2C2;text-align: center;">
            Editer Fiche Prospect {{clientType}}  
        </div>
    </div>



    <div style="height: 70px;" class='col-xs-9 col-sm-9 col-md-9 col-lg-9 '>
        <div class='middle-div' style="color: #E30613;font-size: 16px;font-weight: bold;">
            {{ title }}
            <mat-slide-toggle   style="margin-left: 100px;" *ngIf="selectedClient && selectedClient.type==='P'" (change)="update()"  [(ngModel)]="selectedClient.finance">Payé</mat-slide-toggle>
        </div>
    </div>

</div>

<div class="row" style="height: 50px;background-color: #E0F2FD;"> </div>
<div class="basic-container mat-elevation-z8" *ngIf="selectedProspect" style="background-color: #E0F2FD;">
    <mat-horizontal-stepper (selectionChange)="selectionChange($event)"  [linear]="false" [selectedIndex]='idDetail' #stepper>

        <!-- Personal Form for Step 1 -->
        <mat-step [stepControl]="personalForm">
            <ng-template matStepLabel> Entreprise</ng-template>

            <app-personal-form [typeClient]='this.selectedClient.type' [form]="personalForm" [selectedProspect]='selectedProspect'></app-personal-form>


            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>
            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">


                <div class="top-15">
                    <button mat-stroked-button (click)="saveProspect()" matStepperNext type="button"
                        matTooltip="Next Step" color='primary'>Next</button>
                </div>


            </div>
        </mat-step>

        <!-- Contact Form for Step 2 -->
        <mat-step [stepControl]="contactForm">
            <ng-template matStepLabel> Contact</ng-template>

            <app-contact-form (contactChanged)="contactsChanged()" [form]="contactForm" [selectedClient]='selectedClient' [prospect]='selectedProspect'>
            </app-contact-form>


            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>


            <div style="position: absolute;top: 133px;right: 30px;z-index: 999999;">



                <div class="top-15">
                    <div class="top-15">
                        <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                        <button color='primary' mat-stroked-button matStepperNext (click)="saveContact()">Next</button>
                    </div>
                </div>

            </div>





        </mat-step>


        <mat-step *ngIf="selectedClient.type=='P'">
            <ng-template matStepLabel>Clients</ng-template>



            <div class="row" *ngIf="projectId">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-card>
                        <button mat-raised-button (click)="showListStands=!showListStands">Ajouter un client</button>


                        <app-clients-projet [showListStands]='showListStands' [projectId]='projectId'
                            [clientId]='idClient'></app-clients-projet>

                    </mat-card>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">


                    <mat-card>

                        <app-client-contructeurs [prestatairesClientList]="selectedClient.prestatairesClientList" [clientId]='idClient'></app-client-contructeurs>

                    </mat-card>


                </div>

            </div>

            <div class="top-15" style="position: absolute;top:147px;left: 30px; ">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>

            <div style="position: absolute;top: 147px;right: 30px; ">
                <div class="top-15">
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button color='primary' mat-stroked-button matStepperNext
                        *ngIf="stands && stands.length > 0">Next</button>
                </div>

            </div>

        </mat-step>



        <mat-step *ngIf="selectedClient.type!='P'">
            <ng-template matStepLabel>Stand</ng-template>



            <div class="row" *ngIf="projectId">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <mat-card>
                        <button mat-raised-button (click)="showListStands=!showListStands">Ajouter un Stand</button>


                        <list-stand-projet [showListStands]='showListStands' [projectId]='projectId'
                            [clientId]='idClient'></list-stand-projet>

                    </mat-card>
                </div>

                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">


                    <mat-card>

                        <app-stands-exposant [stands]="stands" [clientId]='idClient'></app-stands-exposant>

                    </mat-card>


                </div>

            </div>

            <div class="top-15" style="position: absolute;top:147px;left: 30px; ">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>

            <div style="position: absolute;top: 147px;right: 30px; ">
                <div class="top-15">
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button color='primary' mat-stroked-button matStepperNext
                        *ngIf="stands && stands.length > 0">Next</button>
                </div>

            </div>

        </mat-step>

        <mat-step [stepControl]="facturationForm">
            <ng-template matStepLabel> Finance </ng-template>
            <app-facturation-form  (onChangedFacture)='initListPanier()' [client]='selectedClient' [form]='facturationForm'></app-facturation-form>


            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>

            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">
                <div class="top-15">


                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button color='primary' mat-stroked-button matStepperNext>Next</button>
                </div>
            </div>
        </mat-step>


        <mat-step style="display: none;">
            <ng-template matStepLabel>Contenu Proforma</ng-template>
            <app-panier-form></app-panier-form>

            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon> Back
                    </a>
                </button>
            </div>


            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">
                <div class="top-15">
<span *ngIf="!isLoadingFacture">
    <span style="margin-top: 3px;"> 
        <p-inputSwitch  [(ngModel)]="isSignature"></p-inputSwitch>
    </span>
    
    <span style="font-size: 14px;font-weight: bold;" *ngIf="isSignature">
        Avec signature
        </span>
         
        <span  style="font-size: 14px;font-weight: bold;" *ngIf="!isSignature">
            Sans signature
        </span>  
  <button *ngIf="false" mat-stroked-button (click)="printInvoice(1,false,true)">
                        <mat-icon class="mat-18">print</mat-icon>
                       Imprimer facture word
                    </button>


                    <button mat-stroked-button (click)="printInvoice(1,false,false)">
                        <mat-icon class="mat-18">print</mat-icon>
                       Imprimer facture
                    </button>
                    <button mat-stroked-button (click)="printInvoice(1,true,false)">
                        <mat-icon class="mat-18">print</mat-icon>
                        Print Proforma invoice
                    </button>&nbsp;  
</span>
<span *ngIf="isLoadingFacture">
    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
</span>


                    
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button color='primary' (click)="saveListPanier()" mat-stroked-button matStepperNext>Next</button>
                </div>
            </div>

        </mat-step>


   

        <mat-step >
            <ng-template matStepLabel>Délégués</ng-template>
            <app-delegate-form [selectedClient]='selectedClient' [prospect]='selectedProspect'></app-delegate-form>

            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon>Back
                    </a>
                </button>
            </div>


            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">
                <div class="top-15">
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button color='primary' mat-stroked-button matStepperNext>Next</button>
                </div>
            </div>
        </mat-step>


        <!-- Result Form for Step 4 -->
        <mat-step *ngIf="selectedClient.type=='P'">
            <ng-template matStepLabel> 
                Maquette
                 </ng-template>
            <app-result-form [idClient]='idClient'></app-result-form>

            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon>Back
                    </a>
                </button>
            </div>



            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">
                <div class="top-15">
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button mat-stroked-button cdkFocusInitial (click)="imprimerDossier()">Imprimer
                        Dossier</button>&nbsp;

                </div>
            </div>
        </mat-step>

        <mat-step *ngIf="selectedClient.type!='P'">
            <ng-template matStepLabel> 
                Preview
                 </ng-template>
            <app-result-form [idClient]='idClient'></app-result-form>

            <div class="top-15" style="position: absolute;top:147px;left: 30px;z-index: 999999;">
                <button style="margin-right: 49px;" mat-icon-button>
                    <a (click)="done=true;retour()">
                        <mat-icon>keyboard_arrow_left </mat-icon>Back
                    </a>
                </button>
            </div>



            <div style="position: absolute;top: 147px;right: 30px;z-index: 999999;">
                <div class="top-15">
                    <button mat-stroked-button matStepperPrevious>Previous</button>&nbsp;
                    <button mat-stroked-button cdkFocusInitial (click)="imprimerDossier()">Imprimer
                        Dossier</button>&nbsp;

                </div>
            </div>
        </mat-step>
   
    </mat-horizontal-stepper>
    <div *ngIf="user" style="padding: 20px;">{{user.nom}}</div>
    <div *ngIf="!user" style="color: red;">Ce client n'a pas d'utilisateur</div>

</div>